import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-delete-schedule-popup',
  templateUrl: './delete-schedule-popup.component.html',
  styleUrls: ['./delete-schedule-popup.component.css']
})
export class DeleteSchedulePopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<object>();
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({
    duplicate_option: new FormControl()
  });

  constructor() { }

  ngOnInit(): void {
    this.componentForm.get('duplicate_option').setValue('option_1');
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    this.success.emit({duplicateChanges: (this.componentForm.get('duplicate_option').value === 'option_2')})
  }

}
